import Typography from "./Typography";
import IconButton from "@mui/material/IconButton";
import { CaretLeft, CaretRight } from "phosphor-react";

type PaginationControlsProps = {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    setPageIndex: (pageIndex: number) => void;
    itemName?: string;
    className?: string;
};

const PaginationControls = ({
    pageIndex,
    pageSize,
    totalCount,
    totalPages,
    hasPreviousPage,
    hasNextPage,
    setPageIndex,
    itemName = "items",
    className = "",
}: PaginationControlsProps) => {
    const handlePreviousPage = () => {
        if (hasPreviousPage) {
            setPageIndex(pageIndex - 1);
        }
    };

    const handleNextPage = () => {
        if (hasNextPage) {
            setPageIndex(pageIndex + 1);
        }
    };

    // If there are no items, don't render the pagination controls
    if (totalCount === 0) return null;

    const startItem = pageIndex * pageSize + 1;
    const endItem = Math.min((pageIndex + 1) * pageSize, totalCount);

    return (
        <div className={`flex items-center justify-between py-2 px-4 ${className}`}>
            <Typography variant="body" component="p" className="text-gray-600">
                Showing {startItem}-{endItem} of {totalCount} {itemName}
            </Typography>
            <div className="flex items-center gap-2">
                <IconButton
                    onClick={handlePreviousPage}
                    disabled={!hasPreviousPage}
                    size="small"
                    aria-label="Previous page"
                >
                    <CaretLeft size={20} />
                </IconButton>
                <div className="flex items-center">
                    <Typography variant="body" component="p">
                        Page {pageIndex + 1} of {totalPages}
                    </Typography>
                </div>
                <IconButton
                    onClick={handleNextPage}
                    disabled={!hasNextPage}
                    size="small"
                    aria-label="Next page"
                >
                    <CaretRight size={20} />
                </IconButton>
            </div>
        </div>
    );
};

export default PaginationControls;